import { type BaseContext } from '../state-machine-types';

export const keep = <T extends BaseContext>(ctx: T) => ctx;
